/**
 * Gestionnaire audio simple et immédiat
 * Pas de délai artificiel - joue le son dès réception
 */

import { getAudioConfiguration } from '@/utils/audio';

let lastPlayedFilename = null;
let audioTimeoutId = null;
let isPlaying = false; // Flag pour éviter les appels simultanés

/**
 * Joue un fichier audio immédiatement
 * @param {string} filename - Nom du fichier audio (ex: "B75", "Message01")
 */
export function playAudio(filename) {
  // Vérifier la configuration audio
  const audioConfig = getAudioConfiguration();
  if (audioConfig === 'off') {
    return;
  }

  // Éviter de jouer le même fichier deux fois ou si déjà en cours de lecture
  if (!filename || filename === '' || filename === lastPlayedFilename || isPlaying) {
    console.info('🔇 Audio ignoré - déjà en cours ou doublon:', filename, '| lastPlayed:', lastPlayedFilename, '| isPlaying:', isPlaying);
    return;
  }

  lastPlayedFilename = filename;
  isPlaying = true;

  try {
    const audioElement = document.getElementById('audioActive');
    if (!audioElement) {
      console.warn('Élément audio non trouvé');
      return;
    }

    // Nettoyer le timeout précédent pour éviter les fuites mémoire
    if (audioTimeoutId) {
      clearTimeout(audioTimeoutId);
      audioTimeoutId = null;
    }

    // Arrêter la lecture en cours et réinitialiser pour éviter les erreurs d'interruption
    if (!audioElement.paused) {
      audioElement.pause();
    }
    audioElement.currentTime = 0;

    // Réinitialiser l'élément audio pour éviter les erreurs "interrupted by a new load request"
    audioElement.load();

    // Construire le chemin du fichier audio
    const audioPath = `/Audio/F/${filename.replace('.mp3', '')}.mp3?v2`;

    // Attendre un petit délai après load() pour s'assurer que l'élément est prêt
    audioTimeoutId = setTimeout(() => {
      try {
        audioElement.src = audioPath;
        const playPromise = audioElement.play();

        // Gérer la promesse de play() correctement
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              // Lecture démarrée avec succès
            })
            .catch((error) => {
              // Ignorer les erreurs AbortError (interruption normale)
              if (error.name !== 'AbortError') {
                console.error('Erreur lors de la lecture audio:', error);
              }
            });
        }
      } catch (error) {
        // Ignorer les erreurs AbortError (interruption normale)
        if (error.name !== 'AbortError') {
          console.error('Erreur dans playAudio:', error);
        }
      } finally {
        // Réinitialiser le flag après un délai pour permettre la prochaine lecture
        setTimeout(() => {
          isPlaying = false;
        }, 100);
      }
      audioTimeoutId = null;
    }, 50); // Petit délai pour laisser l'élément se réinitialiser
  } catch (error) {
    // Ignorer les erreurs AbortError (interruption normale)
    if (error.name !== 'AbortError') {
      console.error('Erreur dans playAudio:', error);
    }
  }
}

